"use client";

import Image from "next/image";
import { type ComponentProps, useState } from "react";
import DemoCheckbox from "@/components/preview/demo-checkbox";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { cn } from "@/lib/utils";

type ImageBorderDemoProps = Pick<
  ComponentProps<typeof DemoWrapper>,
  "captionText" | "height" | "margin"
>;

export default function ImageBorderDemo(props: ImageBorderDemoProps) {
  const [hasBorder, setHasBorder] = useState(false);

  return (
    <DemoWrapper {...props}>
      <div className="flex h-full w-full flex-1 items-center justify-center py-8">
        <div
          className={cn(
            "relative size-48 overflow-hidden rounded-3xl",
            hasBorder && "border-overlay"
          )}
        >
          <Image
            alt="Sea at daytime"
            className="h-full w-full select-none object-cover dark:hidden"
            height={1000}
            src="https://oiszjiwtfc65cwa2.public.blob.vercel-storage.com/details-that-make-interfaces-feel-better/sea.avif"
            width={1000}
          />
          <Image
            alt="Sea at night"
            className="hidden h-full w-full select-none object-cover dark:block"
            height={1000}
            src="https://oiszjiwtfc65cwa2.public.blob.vercel-storage.com/details-that-make-interfaces-feel-better/sea-night.avif"
            width={1000}
          />
        </div>
      </div>
      <DemoFooter>
        <DemoCheckbox
          checked={hasBorder}
          label="Show border"
          onCheckedChange={setHasBorder}
        />
      </DemoFooter>
    </DemoWrapper>
  );
}
